import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const employeeApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/employee",
      params,
    }),

  importExcel: (file: File): AxiosPromise<any> => {
    const formData = new FormData();
    formData.append("file", file);
    return request({
      url: "/v1/admin/employee/import",
      method: "post",
      data: formData,
      timeout: 120000,
    });
  },

  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/employee",
      data,
      method: "post",
    }),

  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/employee/${id}`,
      method: "patch",
      data,
    }),

  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/employee/${id}`,
      method: "delete",
    }),
};

export const departmentApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/department",
      params,
    }),

  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/department",
      data,
      method: "post",
    }),

  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/department/${id}`,
      method: "patch",
      data,
    }),

  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/department/${id}`,
      method: "delete",
    }),
};
